import React, { useCallback, useState, useMemo } from 'react';
import styled, { useTheme } from 'styled-components';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import Content from 'gatsby-theme-pagebuilder/src/components/content';
import Column from 'gatsby-theme-pagebuilder/src/components/column/index';
import Button from 'gatsby-theme-core/src/components/button/index';
import { apollo as mapRefinements } from 'gatsby-theme-vehicles/src/helpers/map-refinements';
import SearchProvider from 'gatsby-theme-vehicles/src/components/search';
import useSearch from 'gatsby-theme-vehicles/src/components/search/hooks/use-search';
import * as filters from 'gatsby-theme-vehicles/src/components/search/filters';

const Titles = styled.div`
  text-align: center;

  h2 {
    margin: 0 0 .5rem 0;
    font-size: 2rem;
  }

  span {
    display: block;
  }
`;

const StyledContent = styled(Content)`
  width: 100%;
`;

const CenteredContent = styled(Content)`
  text-align: center;
  margin-bottom: 2rem;
`;

const MinMax = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > span {
    margin-top: 1rem;
    font-weight: 700;
    font-size: 1.25rem;
  }
`;

const SliderWrapper = styled.div``;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: .5rem;
`;

const markStyle = { display: 'none' };
const dotStyle = { display: 'none' };

const SearchsliderComponent = ({
  title,
  subtitle,
  content,
  slider,
  button,
}) => {
  const { setWhere, to } = useSearch();
  const maxField = filters[`${slider.field}Max`];
  const minField = filters[`${slider.field}Min`];
  const marks = [...minField.options, ...maxField.options].reduce((acc, { name, value }) => ({
    ...acc,
    [value || name]: { style: markStyle, label: value || name },
  }), {});
  const marksArray = Object.keys(marks);
  const defaultValue = [marksArray[0], marksArray[marksArray.length - 1]]
    .map((v) => parseInt(v, 10));
  const [values, setValues] = useState(defaultValue);
  const onChange = useCallback((nextValues) => {
    setWhere({
      [minField.field]: nextValues[0],
      [maxField.field]: nextValues[1],
    });
    setValues(nextValues);
  }, [setWhere, minField.field, maxField.field]);

  const theme = useTheme();
  const heightInRem = '.75rem';
  const railStyle = useMemo(() => ({
    backgroundColor: theme.grayDarkColor,
    height: heightInRem,
  }), [theme, heightInRem]);
  const trackStyle = useMemo(() => ({
    backgroundColor: theme.primaryColor,
    height: heightInRem,
  }), [theme, heightInRem]);
  const handleStyle = useMemo(() => ({
    backgroundColor: theme.primaryColor,
    borderColor: theme.primaryColor,
    opacity: 1,
    width: '1.25rem',
    height: '1.25rem',
  }), [theme]);

  return (
    <>
      <Titles>
        {title && <h2>{title}</h2>}
        {subtitle && <span>{subtitle}</span>}
      </Titles>
      <CenteredContent content={content} />
      <SliderWrapper>
        <Slider
          onChange={onChange}
          dotStyle={dotStyle}
          railStyle={railStyle}
          trackStyle={trackStyle}
          handleStyle={handleStyle}
          min={defaultValue[0]}
          max={defaultValue[1]}
          range
          allowCross={false}
          marks={marks}
          step={null}
          defaultValue={defaultValue}
          value={values}
        />
        <MinMax>
          {values.map((value, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={`${index}-${value}`}>&euro;{value}</span>
          ))}
        </MinMax>
      </SliderWrapper>

      {button && (
        <ButtonWrapper>
          <Button to={to}>
            {button.text}
          </Button>
        </ButtonWrapper>
      )}
    </>
  );
};

const Searchslider = (props) => (
  <Column
    columnWidth={props.columnWidth}
    align={props.align}
    justify={props.justify}
    card={props.card}
    order={props.order}
    offset={props.offset}
  >
    <StyledContent textAlign={props.justify}>
      <SearchProvider
        srp={props.stockPage.searchResultsPage}
        staticCount={props.totalCount}
        groupedOptions={props.groupedOptions}
        replaceUrl={false}
        limit={1} // we dont care about the vehicles, only get 1
        defaultWhere={mapRefinements(props.refinements)}
      >
        <SearchsliderComponent {...props} />
      </SearchProvider>
    </StyledContent>
  </Column>
);

export default styled(Searchslider)``;
